import { NgModule } from '@angular/core';
import { PdfViewerComponent } from './pdf-viewer.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PdfViewerComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [PdfViewerComponent]
})
export class PdfViewerModule { }
